var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":_vm.iframeId,"src":_vm.iframeSrc},on:{"load":_vm.publisher}})])}
var staticRenderFns = []

export { render, staticRenderFns }